import { TextField, Typography } from '@mui/material'
import { FieldError } from 'react-hook-form'

import { useTranslation } from '@/core'
import { CellFrame, Organism } from '@/core/architecture'

type FavoriteMemberNameInputCellProps = {
  value: string
  onChange: (value: string) => void
  error?: FieldError
  translationNamespace: string
  placeholder?: string
}

export const FavoriteMemberNameInputCell: Organism<FavoriteMemberNameInputCellProps> =
  ({ value, onChange, error, translationNamespace, placeholder }) => {
    const { t } = useTranslation(translationNamespace)

    return (
      <CellFrame>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {t('memberName')}
        </Typography>
        <TextField
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder || t('memberNamePlaceholder')}
          fullWidth
          error={!!error}
          helperText={error?.message}
          color="primary"
        />
      </CellFrame>
    )
  }
